import {
    COMMON_GET_PLANS_BEGIN_SUCCESS,
    COMMON_GET_PLANS_BEGIN_FAILURE,
    COMMON_GET_PLANS_BEGIN,
    COMMON_GET_PLANS_BEGIN_DISMISS_ERROR,
  } from './constants'

  import { BFFAgent } from '../../../common/BFFAgent'
  
  export function getPlans() {
    return async (dispatch) => {
      dispatch({
        type: COMMON_GET_PLANS_BEGIN,
      })
      
      try {
        const plans = await BFFAgent.Plans.getPlans()

            dispatch({
                type: COMMON_GET_PLANS_BEGIN_SUCCESS,
                data: plans
            })
       } catch (error) {
          dispatch({
            type: COMMON_GET_PLANS_BEGIN_FAILURE,
            data: { error },
          })
      }
    }
  }
  
  export function dismissGetPlansError() {
    return {
      type: COMMON_GET_PLANS_BEGIN_DISMISS_ERROR,
    }
  }
  
  export function reducer(state, action) {
    switch (action.type) {
      case COMMON_GET_PLANS_BEGIN:
        return {
          ...state,
          getPlansPending: true,
          getPlansError: null,
        }
  
      case COMMON_GET_PLANS_BEGIN_SUCCESS:
        return {
          ...state,
          getPlansPending: false,
          getPlansError: null,
          plans: action.data,
        }
  
      case COMMON_GET_PLANS_BEGIN_FAILURE:
        return {
          ...state,
          getPlansPending: false,
          getPlansError: action.data.error,
        }
  
      case COMMON_GET_PLANS_BEGIN_DISMISS_ERROR:
        return {
          ...state,
          getPlansError: null,
        }
  
      default:
        return state
    }
}
